import iziToast from 'izitoast/dist/js/iziToast.min.js'; 

$(function() {
    iziToast.settings({
        timeout: 2000,
        position: 'topRight',
        iconUrl: './assets/img/check.svg'
    });
   
    function idClickEventHandler() {

        iziToast.success({
            message: 'Synergy ID скопирован'
        });
        const el = $('[data-id]')
        navigator.clipboard.writeText(el.data('id'));
    }
    $('.s-copy-block').on('click', idClickEventHandler)
});